export interface Customer {
  uuid: string;
  name: string;
  internalNotes: string | null;
  hubspotId: string | null;
  hubspotLink: string | null;
}

export interface NewCustomer {
  name: string;
  internalNotes?: string | null;
  hubspotId?: string | null;
}

export const EMPTY_NEW_CUSTOMER: NewCustomer = {
  name: '',
  internalNotes: '',
  hubspotId: '',
};
